import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <>
      <meta name="google-site-verification" content="-3OTkhrHOCPlRzytSpxkqC08r3O4M8aOpN0h9XbZSnA" />
      <Helmet>
        <title>燒石鼎 | 汐止的職人の石頭火鍋</title>
        <meta name="description" content="燒石鼎：汐止的職人の石頭火鍋。最新改良食材：船凍小卷鍋和巨霸海蝦叻沙鍋，讓你在夕陽餘暉下享受美味。" />
        <meta name="keywords" content="燒石鼎, 石頭火鍋, 汐止美食, 小卷鍋, 海蝦鍋, 台式火鍋, 麻辣火鍋, 外帶火鍋, 外送火鍋" />
        <meta name="author" content="燒石鼎" />
      </Helmet>
      <html lang="zh-Hant" />
      <header className="header">
        <h1 className="header-title">燒石鼎</h1>
        <nav className="nav">
          <Link to="/">首頁</Link>
          <Link to="/menu">菜單</Link>
          {/* <Link to="/promotions">促銷</Link> */}
          {/* <Link to="/testimonials">顧客評價</Link> */}
        </nav>
      </header>
    </>
  );
}

export default App;
